import ArticlePage from "./ArticlePage";

export default ArticlePage;
